import React from 'react';
import styles from './BranchIdentityStrip.module.css';
import Pill from '../common/Pill';
import Ico from '../common/Ico';
import ActionsForBranch from './ActionsForBranch';
import { statusLabel } from './statusConfig';
import { timeSinceTS } from '../../helpers/dates';

const ICO_BRANCH  = 'M6 3v12 M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M18 9a9 9 0 0 1-9 9';
const ICO_SERVER  = 'M2 4h20v6H2zM2 14h20v6H2zM6 7h.01M6 17h.01';
const ICO_MOON    = 'M12 3a9 9 0 1 0 9 9c0-.46-.04-.92-.1-1.36A5.39 5.39 0 0 1 12.5 3.1 9.06 9.06 0 0 0 12 3z';
const ICO_CLOCK   = 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zM12 7v5l3 2';
const ICO_EXTERNAL= 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14 21 3';

export default function BranchIdentityStrip({ branch, reloadData }) {
  const testInstance = branch.test_instance;

  return (
    <div className={styles.strip}>
      <div className={styles.inner}>
        <div className={styles.row}>
          {/* avatar tile */}
          <div className={styles.avatar}>
            <Ico d={ICO_BRANCH} size={24} style={{ color: '#fff' }} strokeWidth={1.7} />
          </div>

          {/* identity */}
          <div className={styles.identity}>
            <div className={styles.nameRow}>
              <h1 className={styles.name}>
                Branch <span className={styles.version}>{branch.version}</span>
              </h1>
              {branch.status && (
                <Pill status={branch.status} dot pulse={branch.status === 'branching'}>
                  {statusLabel(branch.status)}
                </Pill>
              )}
              {branch.to_release && <Pill kind="ok">To-release</Pill>}
              <span className={styles.baseBranch}>
                branched from <code className={styles.mono}>main</code>
              </span>
            </div>

            <div className={styles.meta}>
              {testInstance?.url ? (
                <span className={styles.metaItem}>
                  <Ico d={ICO_SERVER} size={14} className={styles.metaIcon} />
                  <span className={styles.metaLabel}>Test instance</span>
                  <a
                    href={`https://${testInstance.url}`}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.metaLink}
                  >
                    {testInstance.url}
                    <Ico d={ICO_EXTERNAL} size={10} />
                  </a>
                  {testInstance.status && (
                    <Pill status={testInstance.status} dot>
                      {statusLabel(testInstance.status)}
                    </Pill>
                  )}
                </span>
              ) : branch.deploy_target ? (
                <span className={styles.metaItem}>
                  <Ico d={ICO_SERVER} size={14} className={styles.metaIcon} />
                  <span className={styles.metaLabel}>Deploy target</span>
                  <span className={styles.metaValue}>{branch.deploy_target}</span>
                </span>
              ) : null}

              {(testInstance?.url || branch.deploy_target) && <span className={styles.dot}>·</span>}

              <span className={styles.metaItem}>
                <Ico d={ICO_MOON} size={14} className={styles.metaIcon} />
                <span className={styles.metaLabel}>Nightly</span>
                <strong className={styles.metaStrong}>
                  {branch.nightly_enabled ? 'Enabled' : 'Disabled'}
                </strong>
              </span>

              {branch.created && (
                <>
                  <span className={styles.dot}>·</span>
                  <span className={styles.metaItem}>
                    <Ico d={ICO_CLOCK} size={14} className={styles.metaIcon} />
                    <span className={styles.metaLabel}>Created</span>
                    <strong className={styles.metaStrong}>{timeSinceTS(branch.created)}</strong>
                  </span>
                </>
              )}
            </div>
          </div>

          {/* actions */}
          <div className={styles.actions}>
            <ActionsForBranch branch={branch} reloadData={reloadData} showToReleaseAction />
          </div>
        </div>
      </div>
    </div>
  );
}
